import React from "react";
import styled from "styled-components";
import Label from "./Label";
import Image from './Image';
const SelectOption = ({ disabled = false, onClick, text, className, imgSrc, imgAlt, imgAltParameters, imgHeight, imgWidth, imgLeftAlign = true, }) => {
    return (React.createElement(DefaultOptionComponent, { disabled: disabled, onClick: onClick, className: className, "data-testid": 'selectOption_defaultOptionComponent' },
        imgLeftAlign &&
            React.createElement(OptionImage, { isVisible: Boolean(imgSrc), alt: imgAlt || text, altParameters: imgAltParameters, height: imgHeight, width: imgWidth, src: imgSrc, leftAlign: true }),
        React.createElement(OptionLabel, { text: text }),
        !imgLeftAlign &&
            React.createElement(OptionImage, { isVisible: Boolean(imgSrc), alt: imgAlt || text, altParameters: imgAltParameters, height: imgHeight, width: imgWidth, src: imgSrc, leftAlign: false })));
};
const OptionLabel = styled(Label) `
`;
const DefaultOptionComponent = styled('li').attrs({
    'data-testid': 'selectOption_defaultOptionComponent'
}) `
  display: flex;
  align-items: center;

  margin: 0;
  padding: 0 12px 0 20px;
  line-height: 32px;
  
  pointer-events: inherit;
  pointer-events: ${props => props.disabled && 'none'};

  opacity: 1;
  opacity: ${props => props.disabled && '0.5'};

  cursor: pointer;
  cursor: ${props => props.disabled && 'not-allowed'};

  :hover {
    background-color: rgba(41,167,236,0.10);
  }
  
  span {
    color: ${props => props.theme.colors.tertiaryText};
  }
`;
const OptionImage = styled(({ height, isVisible, width, ...rest }) => React.createElement(Image, { ...rest })) `
  display: none;
  display: ${props => props.isVisible && 'inline-block'};

  height: 20px;
  height: ${props => props.height};

  width: 20px;
  width: ${props => props.width};

  margin-top: -0.5px;
  margin-right: 0px;
  margin-right: ${props => props.leftAlign && "5px"};
  margin-left: 0px;
  margin-left: ${props => !props.leftAlign && "5px"};
`;
export default SelectOption;
//# sourceMappingURL=SelectOption.js.map